<template>
  <h1>
      {{ title }}
      <span v-if="subTitle">
        {{ subTitle }}
      </span>
    <slot />
  </h1>
</template>

<script>
export default {
  name: 'app-content-title',
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    }
  }
}
</script>

